<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<input [kitTextInput]="model" class="form-control form-control-sm"
  [ngClass]="{ 'is-invalid': model.isValid === false }">

<!-- <input [kitModel]="model" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': model.isValid === false }"> -->